import { render, staticRenderFns } from "./DeleteDeviceModal.vue?vue&type=template&id=0988be3c&class=fill-height"
import script from "./DeleteDeviceModal.vue?vue&type=script&lang=ts"
export * from "./DeleteDeviceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports